import { getMfeLogPayload } from '@src/utils/getMfeLogPayload';

export class AssertionError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.name = 'AssertionError';
  }
}

export const assert = (value: boolean, message: string, initData: Record<string, string> = {}): void => {
  if (!value) {
    if (window.localStorage.getItem('tef-coms-4cs-debug-mode')) {
      const payload = getMfeLogPayload('tef-coms4cs', initData);
      window.console.info('tef-coms: assert log', payload); // eslint-disable-line 
    }
    throw new AssertionError(message);
  }
};
